import { useLingui } from "@lingui/react/macro";
import { useFormContext, type FieldValues } from "react-hook-form";
import styles from "./ActivityCategoryPicker.module.scss";
import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import type { IActivityCategory } from "@medoma/models/activities";
import { CategoryIcon } from "@/components/CategoryIcon/CategoryIcon";
import { activityCategoryDictionary } from "@/api/Activities";

type ActivityCategoryPickerProps = {
  categories: IActivityCategory[];
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export type IActivityCategoryPickerFields = {
  category: IActivityCategory;
};

export const ActivityCategoryPicker = ({
  categories,
  errorMessage,
  onChange,
}: ActivityCategoryPickerProps) => {
  const { register } = useFormContext<FieldValues>();
  const { t } = useLingui();

  return (
    <RadioButtons
      errorMessage={errorMessage}
      orientation="horizontal"
      legend={t`Typ av aktivitet`}
    >
      {categories.map((category) => (
        <RadioButton
          key={category}
          label={{
            text: t(activityCategoryDictionary[category]),
            component: (
              <div className={styles.categoryRadioButton}>
                <CategoryIcon category={category} size="small" />
                {t(activityCategoryDictionary[category])}
              </div>
            ),
          }}
          visualStyle="framed"
          value={category}
          {...register(`category`, {
            required: {
              value: true,
              message: t`Välj en kategori för aktiviteten`,
            },
            onChange,
          })}
        />
      ))}
    </RadioButtons>
  );
};
